import { render, staticRenderFns } from "./SettingsP2PNotificationsFilters.vue?vue&type=template&id=d273cac6&scoped=true&"
import script from "./SettingsP2PNotificationsFilters.vue?vue&type=script&lang=js&"
export * from "./SettingsP2PNotificationsFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d273cac6",
  null
  
)

export default component.exports